var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "messages-popup", attrs: { role: "list" } },
    _vm._l(_vm.entries, function (e) {
      return _c(
        "div",
        {
          key: e.name,
          staticClass: "message-entry",
          attrs: { role: "listitem" },
        },
        [
          _c(
            "a",
            {
              attrs: {
                "data-prop": e.prop,
                target: "_blank",
                href: e.href,
                "data-count": e.count || null,
              },
              on: {
                click: function ($event) {
                  return _vm.clearCount(e)
                },
              },
            },
            [_vm._v(_vm._s(e.name))]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }